<template>
  <div id="app" :class="{'white-app': whiteApp, 'show-footer': showFooter}">
    <!-- <PageTransition :key="$route.fullPath" /> -->
    <Header :white-header="whiteHeader" v-on:update:value="whiteHeader = $event" ref="header"></Header>
    <!-- <transition name="fade" mode="out-in">
    </transition> -->
    <Menu v-if="showMenu"></Menu>
    <!--    <transition name="fade-in-up" mode="out-in">
      <GridFamilyDots v-if="showGridFamilyDots" :family-products="familyProducts" :family-projects="familyProjectsMenu"></GridFamilyDots>
    </transition>-->
    <transition
      :name="transitionName"
      mode="out-in"
      @before-enter="beforeEnter"
      @before-leave="beforeLeave"
    >
<!--      <router-view :familias="familyProducts" v-on:update:value="familyProducts = $event" />-->
      <router-view />
    </transition>
    <Footer v-if="showFooter" ref="footer"></Footer>
    <!-- <transition name="fade-in-up" mode="out-in">
      <Menu v-if="showMenu"></Menu>
    </transition> -->
    <Loading v-if="showLoading"></Loading>
    <WorkSelected v-if="workSelected !== null" :work="workSelected" @closeWork="closeWork()"></WorkSelected>
  </div>
</template>

<script>
import Header from './components/Header'
import Menu from './components/Menu'
// import GridFamilyDots from './components/GridFamilyDots'
import { EventBus } from './event-bus'
import { isMobileOnly } from 'mobile-device-detect'
import Loading from './components/Loading'
import Helper from './helpers/Helper'
import Footer from './components/Footer'
// import ObrasService from './services/ObrasService'
import WorkSelected from '@/components/works/WorkSelected'
// import PageTransition from './components/PageTransition.vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const DEFAULT_TRANSITION = 'fade'
export default {
  name: 'App',
  metaInfo: {
    title: 'Grupo MSH - Shaping the future',
    meta: [
      { name: 'description', content: 'MSH es una compañía de diseño e innovación industrial que ofrece soluciones personalizadas para desafíos arquitectónicos no convencionales.' },
      { name: 'keywords', content: 'arquitectura, innovación industrial, ingeniería, pieles arquitectonicas, quiebravistas, cielorrasos, fachadas móviles, custom design' },
      { property: 'og:title', content: 'Grupo MSH - Shaping the future' },
      { property: 'og:description', content: 'MSH es una compañía de diseño e innovación industrial que ofrece soluciones personalizadas para desafíos arquitectónicos no convencionales.' },
      { name: 'theme-color', content: '#1A1A1A' }
    ]
  },
  data () {
    return {
      isMobileOnly,
      showMenu: false,
      // showGridFamilyDots: false,
      showLoading: false,
      whiteHeader: false,
      transitionName: DEFAULT_TRANSITION,
      // familyProducts: [],
      whiteApp: false,
      // familyProjectsMenu: [],
      workSelected: null,
      showFooter: true,
      logo: null,
      observer: null
    }
  },
  components: {
    Header,
    Menu,
    Loading,
    WorkSelected,
    Footer
    // PageTransition
  },
  mounted () {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION

      next()
    })

    // if (!isMobileOnly) {
    //   this.getProjectsFamilyMenu()
    // }

    this.showFooter = !(Helper.isInURL('contact'))

    // this.whiteHeader = this.$route.path.includes('/works')
    // this.whiteApp = this.$route.path === '/works'

    EventBus.$on('toggleMenu', (showMenu) => {
      this.showMenu = showMenu
      EventBus.$emit('toggleMenuIcon', !showMenu)
      EventBus.$emit('showMailIcon', !showMenu)
    })
    EventBus.$on('toggleGridFamilyDots', (showGrid) => {
      // this.showGridFamilyDots = showGrid
      // EventBus.$emit('toggleGridFamilyIcon', !showGrid)
    })
    EventBus.$on('toggleLoading', (toggle) => {
      this.showLoading = toggle
    })

    // EventBus.$on('familyProducts', (familyProducts) => {
    //   this.familyProducts = familyProducts
    // })

    EventBus.$on('bodyScroll', (bodyScrollToggle) => {
      this.toggleBodyScroll(bodyScrollToggle)
    })

    EventBus.$on('showWork', (work, color) => {
      const nameFull = work.nombre.split(' ').join('-')
      this.$router.push({ name: 'Work', params: { work: `${work.id}-${nameFull}` }, query: { name: work.nombre, color } })
      // this.showWork(work)
    })

    EventBus.$on('showFooter', (show) => {
      this.showFooter = show
    })

    EventBus.$on('changeLanguage', () => {
      const locale = (this.$i18n.locale === 'es') ? 'en' : 'es'
      this.changeLanguage(locale)
    })

    /* window.addEventListener('scroll', () => {
      EventBus.$emit('showMailHeader', ((window.innerHeight + window.scrollY) >= document.body.offsetHeight))
    }) */

    // this.initLogoAnimation()
    window.onload = () => {
      this.setupFooterObserver()
    }
  },
  methods: {
    beforeEnter (el) {
      // this.showLoading = !this.showLoading
    },
    beforeLeave (el) {
      // this.showLoading = !this.showLoading
    },
    toggleBodyScroll (bodyScrollToggle) {
      document.body.classList.toggle('no-scroll', !bodyScrollToggle)
    },

    // getProjectsFamilyMenu () {
    //   const service = new ObrasService()
    //   service.findAll({ for: 1 }, (response) => {
    //     this.familyProjectsMenu = response
    //   })
    // },
    showWork (work) {
      this.workSelected = work
    },
    closeWork () {
      this.workSelected = null
    },

    changeLanguage (locale) {
      this.$i18n.locale = locale
      const to = this.$router.resolve({ params: { locale } })
      // this.$router.push(to.location)
      window.location.href = to.href
    },
    setupFooterObserver () {
      if (this.isMobileOnly) return // Evita ejecutar la animación en móviles

      this.$nextTick(() => {
        // Desconectar el observer previo si existe
        if (this.observer) {
          this.observer.disconnect()
        }

        // Esperar un poco más para asegurar que el footer se ha renderizado
        setTimeout(() => {
          const footer = this.$refs.footer?.$el
          if (!footer) return

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.initLogoAnimation()
                  this.observer.disconnect() // Detenemos la observación para no volver a llamarlo
                }
              })
            },
            { threshold: 0.1 } // Se activará cuando al menos un 10% del footer esté en pantalla
          )

          this.observer.observe(footer)
        }, 1000) // Pequeño retraso para esperar el renderizado completo
      })
    },
    initLogoAnimation () {
      this.$nextTick(() => {
        const logo = this.$refs.header.$el.querySelector('.header-logo')
        const footer = this.$refs.footer.$el

        if (!logo || !footer) return

        // Función para calcular la altura del logo según la pantalla
        const getDynamicHeight = () => {
          const baseHeight = 160 // Tamaño máximo del logo
          const screenHeight = window.innerHeight // Altura actual de la pantalla
          const referenceHeight = 695 // Altura de referencia donde el logo es 160px

          // Ajuste de tolerancia: hace que el logo se reduzca más rápidamente en pantallas pequeñas
          const reductionFactor = 0.5 // Puedes ajustar este factor para hacerlo más pronunciado
          const adjustedHeight = screenHeight < referenceHeight
            ? Math.max(40, (screenHeight / (referenceHeight / reductionFactor)) * baseHeight) // Reducción más fuerte
            : baseHeight

          // Asegurarse de que el logo no supere el tamaño máximo (160px)
          return Math.min(adjustedHeight, baseHeight) // Nunca supera los 160px
        }

        // 🛑 Limpiar todos los ScrollTriggers antes de agregar uno nuevo
        // ScrollTrigger.getAll().forEach((t) => t.kill());

        gsap.to(logo, {
          height: () => `${getDynamicHeight()}px`, // Altura dinámica
          duration: 1,
          ease: 'none',
          scrollTrigger: {
            trigger: footer,
            start: 'top bottom-=50%',
            end: 'bottom bottom',
            scrub: true,
            onEnter: () => EventBus.$emit('showMailHeader', true),
            onLeaveBack: () => EventBus.$emit('showMailHeader', false)
          }
        })

        // 🛑 Escuchar cambios de tamaño de pantalla para actualizar la animación
        window.addEventListener('resize', () => {
          gsap.to(logo, { height: `${getDynamicHeight()}px`, duration: 0.3 })
        })
      })
    }
  },
  watch: {
    $route: {
      handler (to, from) {
        ScrollTrigger.getAll().forEach((t) => t.kill())
        this.$nextTick(() => {
          window.scrollTo({ top: 0 })
        })

        document.querySelector('.header-logo').style.height = '40px'

        this.toggleBodyScroll(true)
        EventBus.$emit('toggleGridFamilyIcon', true)
        if (!Helper.isInURL('family-product') && !Helper.isInURL('product')) {
          EventBus.$emit('headerFamilySelected', null)
        }

        if (to.name === 'Works') {
          EventBus.$emit('familyProducts', this.familyProducts)
          EventBus.$emit('toggleMenuIcon', true)
        }
        if (to.name === 'Home' || to.name === 'Wallpapers' || to.name === 'Brochure') {
          EventBus.$emit('toggleMenuIcon', true)
        }

        EventBus.$emit('showContactsIcons', to.name === 'Contact')

        // EventBus.$emit('toggleHeaderFamilyIcons', (to.name !== 'GPTW' && to.name !== 'products'))

        EventBus.$emit('toggleGridFamilyIcon', (to.name === 'Materiales' || to.name === 'Material' || to.name === 'About'))

        this.showFooter = !(Helper.isInURL('contact'))

        if (this.showFooter) {
          this.setupFooterObserver()
        }
      }
    },
    showMenu: {
      handler () {
        // EventBus.$emit('toggleHeaderFamilyIcons', !this.showMenu && (this.$route.name !== 'GPTW' && this.$route.name !== 'products'))
      }
    }
  }
}
</script>

<style lang="scss">
@import '/assets/scss/app';
@import "/assets/scss/transitions/fade/fade";
@import "/assets/scss/transitions/fade/fade-in-left";
@import "/assets/scss/transitions/fade/fade-in-right";
@import "/assets/scss/transitions/fade/fade-in-up";
@import "/assets/scss/transitions/fade/fade-in-down";
@import "assets/scss/transitions/fade/fade-in-right-group";

  #app {
    overflow-x: hidden;
    background-color: #000000;
    //&.white-app {
    //  background-color: #FFFFFF;
    //}
    //&.show-footer {
    //  margin-bottom: 52px;  //ALTO DEL FOOTER
    //}
  }
/*@include media-breakpoint-down(sm) {
  #app {
    &.show-footer {
      margin-bottom: 60px;  //ALTO DEL FOOTER
    }
  }
}
  @include media-breakpoint-down(xs) {
    #app {
      &.show-footer {
        margin-bottom: 84px;  //ALTO DEL FOOTER
      }
    }
  }*/
</style>
